import React from "react";
import Facts_Table from "./Facts_table";
import { Card, CardBody, CardHeader } from "reactstrap";

const Facts_list = () => {
  return (
    <div>
      <Card>
        <CardHeader>لیست نیروگاه ها</CardHeader>
        <CardBody>
          <Facts_Table />
        </CardBody>
      </Card>
    </div>
  );
};

export default Facts_list;
